import { RotateCcw } from 'lucide-react';

/**
 * "Restore unsaved draft?" affordance rendered above a form when `useDraft`
 * finds a stored draft for the current key. Never applies the draft
 * silently — the user decides.
 */
export function DraftRestorePrompt({
  onRestore,
  onDiscard,
  label = 'Restore unsaved draft?',
}: {
  onRestore: () => void;
  onDiscard: () => void;
  label?: string;
}) {
  return (
    <div
      role="status"
      className="flex items-center justify-between gap-3 rounded-lg border border-border bg-secondary/50 px-3 py-2 text-sm"
    >
      <span className="inline-flex items-center gap-2">
        <RotateCcw className="size-3.5 text-muted-foreground" strokeWidth={1.75} />
        {label}
      </span>
      <span className="flex items-center gap-2">
        <button
          type="button"
          onClick={onDiscard}
          className="rounded-md border border-border px-2.5 py-1 text-xs hover:bg-secondary"
        >
          Discard
        </button>
        <button
          type="button"
          onClick={onRestore}
          className="rounded-md bg-primary px-2.5 py-1 text-xs font-medium text-primary-foreground hover:bg-primary/90"
        >
          Restore
        </button>
      </span>
    </div>
  );
}
